export const VIEW_PAGE_COURSE_DETAIL = 'COURSE_DETAIL';
export const BUY_MEMBERSHIP = 'Buy membership';
export const CLICK_ON_LESSON = 'Click on lesson';
export const BUY_FROM_STICKY = 'Buy from sticky';
